var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_113_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 9.16666C16.6666 10.65 16.2268 12.1001 15.4027 13.3334C14.5785 14.5668 13.4072 15.5281 12.0368 16.0958C10.6663 16.6634 9.15831 16.8119 7.70345 16.5225C6.24859 16.2332 4.91222 15.5189 3.86333 14.47C2.81443 13.4211 2.10013 12.0847 1.81074 10.6298C1.52135 9.17498 1.66988 7.66698 2.23753 6.29653C2.80519 4.92608 3.76648 3.75474 4.99985 2.93063C6.23322 2.10652 7.68327 1.66666 9.16663 1.66666C11.1558 1.66666 13.0634 2.45683 14.4699 3.86336C15.8765 5.26988 16.6666 7.17753 16.6666 9.16666Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.775 17.2417C16.2166 18.575 17.225 18.7083 18 17.5417C18.7083 16.475 18.2416 15.6 16.9583 15.6C16.7545 15.5804 16.5492 15.6144 16.3627 15.6989C16.1762 15.7833 16.0151 15.9151 15.8954 16.0812C15.7757 16.2472 15.7016 16.4417 15.6804 16.6454C15.6593 16.849 15.6919 17.0546 15.775 17.2417Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_113_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f875d9a2b7af33f42898f23d064c6be0.svg";
export { ForwardRef as ReactComponent };